import { useSelector } from "react-redux";
import store from "../../storeWire";
import {
    setFilterList,
    clearFilterByKey,
    clearAllFilter,
} from "../../store/slice/model/QuoteFilterSelection";

export function useFilterSelectionStore() {
    const filter_list = useSelector((state) => state.entities.model_filter_selection.filterList)

    let data = {
        filter_list
    };
    let fetch = {
    };
    let set = {
        set_filter_list: async (params) => {
            return await store.dispatch(setFilterList(params))
        },
        clear_filter_by_key: async (params) => {
            return await store.dispatch(clearFilterByKey(params))
        },
        clear_all_filter: async () => {
            return await store.dispatch(clearAllFilter())
        }
    };
    return [data, fetch, set]
}